/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/* !!              AUTOMATIC GENERATION             !! */
/* !!           Do not touch this document          !! */
/* !!        If you want to modify something,       !! */
/* !! it's in /parameters or in scripts/generator/  !! */
/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

import type {
  CreateAccount,
  UpdateAccount,
  AccountEmail,
  CreateAccountWithoutAuth,
  CreateAccountAddToCompany,
  UpdatePassword,
  Password,
  Login,
  DeviceType,
  DeviceUuid,
  CreateDevice,
  UpdateDevice,
  CreateCompany,
  Company,
  CompanyId,
  BuildingId,
  CreateBuilding,
  Building,
  BreedingId,
  CreateBreeding,
  Breeding,
  AssociateDeviceToUser,
  LicensePost,
  LicenseDelete,
  LicenseOrders,
  LicenseRegulate,
  AccountWithoutPassword,
  AccountList,
  AllDataAccountList,
  DeviceWithoutLegacyPasswordList2,
  DeviceWithoutLegacyPasswordList,
  DeviceWithoutLegacyPassword,
  AllDataDeviceList,
  CompanyList,
  BuildingList,
  BreedingList,
  BatchList,
  RemoteConnectionPage,
  LoginHistoryPage,
  LicenseHistoryPage,
  LicenseProviderList,
} from "./types";

// Type pour la définition des routes
export type RouteDefinition = {
  table: string;
  method: string;
  path: string;
  request: string;
  response: string;
  description: string;
  status: readonly number[];
  userType: readonly string[];
  requiresToken: boolean;
};

// Définition des routes
export const routes = {
  getAccountProfile: {
    table: "Account",
    method: "GET",
    path: "/account/profile",
    request: "x",
    response: "AccountWithoutPassword",
    description: "Retourne ses propres informations",
    status: [200, 204, 401, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAccountProfileEmail: {
    table: "Account",
    method: "GET",
    path: "/account/profile/{email}",
    request: "x",
    response: "AccountWithoutPassword",
    description: "Retourne les infos du profil email",
    status: [200, 204, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAccounts: {
    table: "Account",
    method: "GET",
    path: "/accounts",
    request: "x",
    response: "AccountList",
    description: "Retourne tous les profils",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminAccountsAlldata: {
    table: "Account",
    method: "GET",
    path: "/admin/accounts/all-data",
    request: "x",
    response: "AllDataAccountList",
    description:
      "Retourne toutes les donnees d un utilisateur (compte, entreprise, elevage, building, device, etc.) (Route admin)",
    status: [200, 400, 401, 403, 500] as const,
    userType: ["admin", "psc"] as const,
    requiresToken: true,
  } as const,
  postLogout: {
    table: "Account",
    method: "POST",
    path: "/logout",
    request: "x",
    response: "x",
    description: "Deconnecte un utilisateur",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postAccounts: {
    table: "Account",
    method: "POST",
    path: "/accounts",
    request: "CreateAccount",
    response: "x",
    description: "Création d'un utilisateur",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putAccounts: {
    table: "Account",
    method: "PUT",
    path: "/accounts",
    request: "UpdateAccount",
    response: "x",
    description: "Modification de compte",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteAccountsId: {
    table: "Account",
    method: "DELETE",
    path: "/accounts/{id}",
    request: "AccountEmail",
    response: "x",
    description: "Suppression de compte",
    status: [200, 400, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postAccountsNoauth: {
    table: "Account",
    method: "POST",
    path: "/accounts/no-auth",
    request: "CreateAccountWithoutAuth",
    response: "x",
    description: "Crée un compte eleveursans authentification",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postAccountsAdd: {
    table: "Account",
    method: "POST",
    path: "/accounts/add",
    request: "CreateAccountAddToCompany",
    response: "x",
    description:
      "Crée un compte utilisateur et l'ajoute à l'entreprise du créateur",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putAccountsUpdateoldpassword: {
    table: "Account",
    method: "PUT",
    path: "/accounts/update-old-password",
    request: "UpdatePassword",
    response: "x",
    description: "Met à jour le mdp d'un utilisateur en vérifiant l'ancien mdp",
    status: [200, 400, 401, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postSendmailtocreatepassword: {
    table: "Account",
    method: "POST",
    path: "/sendmail-to-create-password",
    request: "AccountEmail",
    response: "x",
    description: "Envoie un mail pour créer un mdp",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postAdminUpdatepasswordwithtoken: {
    table: "Account",
    method: "POST",
    path: "/admin/update-password-with-token",
    request: "Password",
    response: "x",
    description: "Met à jour le mdp d'un user avec un token d'administration",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postAdminUpdatepasswordwithlogin: {
    table: "Account",
    method: "POST",
    path: "/admin/update-password-with-login",
    request: "Login",
    response: "x",
    description: "Met à jour le mdp d'un user en tant qu'admin",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postLogin: {
    table: "Account",
    method: "POST",
    path: "/login",
    request: "Login",
    response: "x",
    description: "Connexion utilisateur",
    status: [200, 400, 403, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postVerifyemail: {
    table: "Account",
    method: "POST",
    path: "/verify-email",
    request: "AccountEmail",
    response: "x",
    description: "Verifie si l'email est disponible",
    status: [200, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  getDevices: {
    table: "Device",
    method: "GET",
    path: "/devices",
    request: "x",
    response: "DeviceWithoutLegacyPasswordList2",
    description:
      "Récupère tous les devices de l'utilisateur via sa hiérarchie d'entreprise",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminDevices: {
    table: "Device",
    method: "GET",
    path: "/admin/devices",
    request: "x",
    response: "DeviceWithoutLegacyPasswordList2",
    description: "Récupère tous les devices",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminDevicesTypeType: {
    table: "Device",
    method: "GET",
    path: "/admin/devices/type/{type}",
    request: "DeviceType",
    response: "DeviceWithoutLegacyPasswordList",
    description: "Récupère tous les devices par type",
    status: [200] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  getDevicesUuidUuid: {
    table: "Device",
    method: "GET",
    path: "/devices/uuid/{uuid}",
    request: "DeviceUuid",
    response: "DeviceWithoutLegacyPassword",
    description: "Récupère un device par son uuid",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminDevicesByCompanyUuid: {
    table: "Device",
    method: "GET",
    path: "/admin/devices/byCompany/{uuid}",
    request: "DeviceUuid",
    response: "DeviceWithoutLegacyPasswordList2",
    description:
      "Récupère tous les devices d'une entreprise via l'UUID d'un device",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postDevices: {
    table: "Device",
    method: "POST",
    path: "/devices",
    request: "CreateDevice",
    response: "x",
    description: "Crée un device",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putDevices: {
    table: "Device",
    method: "PUT",
    path: "/devices",
    request: "UpdateDevice",
    response: "x",
    description: "Met à jour la license d'un device",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteDevicesUuid: {
    table: "Device",
    method: "DELETE",
    path: "/devices/{uuid}",
    request: "DeviceUuid",
    response: "x",
    description: "Supprime un device",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminDevicesAlldata: {
    table: "Device",
    method: "GET",
    path: "/admin/devices/all-data",
    request: "x",
    response: "AllDataDeviceList",
    description:
      "Récupère tous des devices de l'entreprise avec les details associes",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getDevicesBuildingNotassociatedId_company: {
    table: "Device",
    method: "GET",
    path: "/devices/building/not-associated/{id_company}",
    request: "x",
    response: "DeviceWithoutLegacyPasswordList2",
    description:
      "Récupère tous des devices non associés à un batiment pour une entreprise",
    status: [200, 204, 400, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getCompanies: {
    table: "Company",
    method: "GET",
    path: "/companies",
    request: "x",
    response: "CompanyList",
    description: "Récupère toutes les entreprises",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getCompanyId: {
    table: "Company",
    method: "GET",
    path: "/company/{id}",
    request: "x",
    response: "Company",
    description: "Récupère une entreprise par son id",
    status: [200] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postCompanies: {
    table: "Company",
    method: "POST",
    path: "/companies",
    request: "CreateCompany",
    response: "x",
    description: "Crée une entreprise",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  putCompanies: {
    table: "Company",
    method: "PUT",
    path: "/companies",
    request: "Company",
    response: "x",
    description: "Met à jour une entreprise",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteCompaniesId: {
    table: "Company",
    method: "DELETE",
    path: "/companies/{id}",
    request: "CompanyId",
    response: "x",
    description: "Supprime une entreprise",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminBuildings: {
    table: "Building",
    method: "GET",
    path: "/admin/buildings",
    request: "x",
    response: "BuildingList",
    description: "Récupère tous les batiments",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBuildings: {
    table: "Building",
    method: "GET",
    path: "/buildings",
    request: "x",
    response: "BuildingList",
    description:
      "Recupere les batiments de l entreprise de l utilisateur connecte",
    status: [200, 400, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBuildingsCompanyId_company: {
    table: "Building",
    method: "GET",
    path: "/buildings/company/{id_company}",
    request: "x",
    response: "BuildingList",
    description: "Recupere les batiments d une entreprise donnee",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBuildingId: {
    table: "Building",
    method: "GET",
    path: "/building/{id}",
    request: "BuildingId",
    response: "Building",
    description: "Récupère un batiment par son id",
    status: [200] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postBuildings: {
    table: "Building",
    method: "POST",
    path: "/buildings",
    request: "CreateBuilding",
    response: "x",
    description: "Crée un batiment",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putBuildings: {
    table: "Building",
    method: "PUT",
    path: "/buildings",
    request: "Building",
    response: "x",
    description: "Met à jour un batiment",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteBuildingsId: {
    table: "Building",
    method: "DELETE",
    path: "/buildings/{id}",
    request: "BuildingId",
    response: "x",
    description: "Supprime un batiment",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getDevicesUuidMeasures: {
    table: "Device",
    method: "GET",
    path: "/devices/{uuid}/measures",
    request: "x",
    response: "x",
    description:
      "Mesures du lot ouvert d un regulateur avec son contexte (batiment lot droits) relais BIGDATA",
    status: [200, 400, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminBreedings: {
    table: "Breeding",
    method: "GET",
    path: "/admin/breedings",
    request: "x",
    response: "BreedingList",
    description: "Récupère tous les élevages",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBreedingId: {
    table: "Breeding",
    method: "GET",
    path: "/breeding/{id}",
    request: "BreedingId",
    response: "Breeding",
    description: "Récupère un élevage par son id",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBreedings: {
    table: "Breeding",
    method: "GET",
    path: "/breedings",
    request: "x",
    response: "BreedingList",
    description: "Récupère tous les élevages de l'enteprise de l'utilisateur",
    status: [200] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postBreedings: {
    table: "Breeding",
    method: "POST",
    path: "/breedings",
    request: "CreateBreeding",
    response: "x",
    description: "Crée un élevage",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putBreedings: {
    table: "Breeding",
    method: "PUT",
    path: "/breedings",
    request: "Breeding",
    response: "x",
    description: "Met à jour un élevage",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteBreedingsId: {
    table: "Breeding",
    method: "DELETE",
    path: "/breedings/{id}",
    request: "BreedingId",
    response: "x",
    description: "Supprime un élevage",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getBatchesAll: {
    table: "Batch",
    method: "GET",
    path: "/batches/all",
    request: "x",
    response: "BatchList",
    description: "Récupère tous les lots",
    status: [200] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  getBatchesUuid: {
    table: "Batch",
    method: "GET",
    path: "/batches/{uuid}",
    request: "x",
    response: "BatchList",
    description: "Récupère tous les lots d'un device",
    status: [200] as const,
    userType: [] as const,
    requiresToken: false,
  } as const,
  postBatches: {
    table: "Batch",
    method: "POST",
    path: "/batches",
    request: "x",
    response: "x",
    description: "Crée un lot",
    status: [201, 400, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putBatches: {
    table: "Batch",
    method: "PUT",
    path: "/batches",
    request: "x",
    response: "x",
    description: "Met à jour un lot",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteBatchesId: {
    table: "Batch",
    method: "DELETE",
    path: "/batches/{id}",
    request: "x",
    response: "x",
    description: "Supprime un lot",
    status: [200, 400, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getPartnerships: {
    table: "Partnership",
    method: "GET",
    path: "/partnerships",
    request: "x",
    response: "x",
    description:
      "Liste les partenariats de son entreprise (filtres status et role)",
    status: [200, 204, 400, 401, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postPartnerships: {
    table: "Partnership",
    method: "POST",
    path: "/partnerships",
    request: "x",
    response: "x",
    description: "Demande un partenariat a partir d un email (reponse opaque)",
    status: [202, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putPartnershipsIdAccept: {
    table: "Partnership",
    method: "PUT",
    path: "/partnerships/{id}/accept",
    request: "x",
    response: "x",
    description: "Accepte une demande de partenariat en attente",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putPartnershipsIdRefuse: {
    table: "Partnership",
    method: "PUT",
    path: "/partnerships/{id}/refuse",
    request: "x",
    response: "x",
    description: "Refuse une demande de partenariat en attente",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deletePartnershipsId: {
    table: "Partnership",
    method: "DELETE",
    path: "/partnerships/{id}",
    request: "x",
    response: "x",
    description: "Rompt un partenariat",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getPartnershipsIdShares: {
    table: "Partnership",
    method: "GET",
    path: "/partnerships/{id}/shares",
    request: "x",
    response: "x",
    description:
      "Liste les produits partageables avec un partenaire et leur etat",
    status: [200, 204, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postPartnershipsIdShares: {
    table: "Partnership",
    method: "POST",
    path: "/partnerships/{id}/shares",
    request: "x",
    response: "x",
    description: "Partage une ressource avec un partenaire",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deletePartnershipsIdSharesResource_typeId_resource: {
    table: "Partnership",
    method: "DELETE",
    path: "/partnerships/{id}/shares/{resource_type}/{id_resource}",
    request: "x",
    response: "x",
    description: "Retire une ressource du partage",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getPartnershipsIdSharesId_shareContacts: {
    table: "Partnership",
    method: "GET",
    path: "/partnerships/{id}/shares/{id_share}/contacts",
    request: "x",
    response: "x",
    description: "Liste les collaborateurs et leur affectation a un partage",
    status: [200, 204, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postPartnershipsIdSharesId_shareContacts: {
    table: "Partnership",
    method: "POST",
    path: "/partnerships/{id}/shares/{id_share}/contacts",
    request: "x",
    response: "x",
    description: "Affecte un collaborateur a un partage",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deletePartnershipsIdSharesId_shareContactsId_account: {
    table: "Partnership",
    method: "DELETE",
    path: "/partnerships/{id}/shares/{id_share}/contacts/{id_account}",
    request: "x",
    response: "x",
    description: "Retire un collaborateur d un partage",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getPartnershipsIdReceivedshares: {
    table: "Partnership",
    method: "GET",
    path: "/partnerships/{id}/received-shares",
    request: "x",
    response: "x",
    description: "Liste les ressources qu un client m a partagees",
    status: [200, 204, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getPartnershipsIdCollaborators: {
    table: "Partnership",
    method: "GET",
    path: "/partnerships/{id}/collaborators",
    request: "x",
    response: "x",
    description: "Equipe et niveau d acces sur un partenariat",
    status: [200, 204, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putPartnershipsIdCollaboratorsId_account: {
    table: "Partnership",
    method: "PUT",
    path: "/partnerships/{id}/collaborators/{id_account}",
    request: "x",
    response: "x",
    description: "Active ou desactive un droit d un collaborateur",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getCollaboratorsId_accountShares: {
    table: "CollaboratorShare",
    method: "GET",
    path: "/collaborators/{id_account}/shares",
    request: "x",
    response: "x",
    description:
      "Liste les elevages et batiments de mon entreprise et leur partage avec un collaborateur",
    status: [200, 204, 400, 401, 403, 404, 500] as const,
    userType: ["breeder"] as const,
    requiresToken: true,
  } as const,
  postCollaboratorsId_accountShares: {
    table: "CollaboratorShare",
    method: "POST",
    path: "/collaborators/{id_account}/shares",
    request: "x",
    response: "x",
    description: "Partage un elevage ou un batiment avec un collaborateur",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: ["breeder"] as const,
    requiresToken: true,
  } as const,
  deleteCollaboratorsId_accountSharesResource_typeId_resource: {
    table: "CollaboratorShare",
    method: "DELETE",
    path: "/collaborators/{id_account}/shares/{resource_type}/{id_resource}",
    request: "x",
    response: "x",
    description:
      "Retire un elevage ou un batiment du partage avec un collaborateur",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: ["breeder"] as const,
    requiresToken: true,
  } as const,
  putDevicesAssociatedevicetouser: {
    table: "Device",
    method: "PUT",
    path: "/devices/associate-device-to-user",
    request: "AssociateDeviceToUser",
    response: "x",
    description: "Associe un produit a une entreprise",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  putDevicesId_deviceBuildingId_building: {
    table: "Device",
    method: "PUT",
    path: "/devices/{id_device}/building/{id_building}",
    request: "x",
    response: "x",
    description:
      "Rattache a un batiment un produit deja associe a l entreprise",
    status: [200, 400, 401, 403, 404, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getAdminRemoteconnections: {
    table: "RemoteConnection",
    method: "GET",
    path: "/admin/remoteconnections",
    request: "x",
    response: "RemoteConnectionPage",
    description:
      "Retourne une page d historique des connexions a distance (filtres + pagination). Route admin",
    status: [200, 400, 401, 403, 500] as const,
    userType: ["admin", "psc"] as const,
    requiresToken: true,
  } as const,
  getAdminLoginhistory: {
    table: "LoginHistory",
    method: "GET",
    path: "/admin/loginhistory",
    request: "x",
    response: "LoginHistoryPage",
    description:
      "Retourne une page d historique des connexions utilisateurs (filtres + pagination). Route admin",
    status: [200, 400, 401, 403, 500] as const,
    userType: ["admin", "psc"] as const,
    requiresToken: true,
  } as const,
  getAdminLicensehistory: {
    table: "LicenseHistory",
    method: "GET",
    path: "/admin/licensehistory",
    request: "x",
    response: "LicenseHistoryPage",
    description:
      "Retourne une page d historique des attributions de licences (filtres + pagination). Route admin",
    status: [200, 400, 401, 403, 500] as const,
    userType: ["admin", "psc"] as const,
    requiresToken: true,
  } as const,
  getAdminLicenseProvidersId_company: {
    table: "LicenseHistory",
    method: "GET",
    path: "/admin/license/providers/{id_company}",
    request: "x",
    response: "LicenseProviderList",
    description:
      "Retourne les installateurs partenaires d une entreprise avec leur stock de licences. Route admin",
    status: [200, 204, 400, 401, 403, 500] as const,
    userType: ["admin", "psc"] as const,
    requiresToken: true,
  } as const,
  postLicense: {
    table: "License",
    method: "POST",
    path: "/license",
    request: "LicensePost",
    response: "x",
    description: "Affecte des codes licence a un produit",
    status: [200, 400, 401, 403, 404, 409, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  deleteLicense: {
    table: "License",
    method: "DELETE",
    path: "/license",
    request: "LicenseDelete",
    response: "x",
    description: "Retire la cle d activation d un produit",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getLicenseUuid: {
    table: "License",
    method: "GET",
    path: "/license/{uuid}",
    request: "x",
    response: "x",
    description: "Recupere les codes licence actifs d un produit",
    status: [200, 400, 401, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  getLicenseSummaryId_company: {
    table: "License",
    method: "GET",
    path: "/license/summary/{id_company}",
    request: "x",
    response: "x",
    description: "Recupere les compteurs de licences d une entreprise",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postLicenseOrders: {
    table: "License",
    method: "POST",
    path: "/license/orders",
    request: "LicenseOrders",
    response: "x",
    description: "Enregistre les commandes de licences d une entreprise",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
  postLicenseRegulate: {
    table: "License",
    method: "POST",
    path: "/license/regulate",
    request: "LicenseRegulate",
    response: "x",
    description: "Ajuste le stock de licences d une entreprise",
    status: [200, 400, 401, 403, 500] as const,
    userType: [] as const,
    requiresToken: true,
  } as const,
} as const;

// Types utilitaires pour inférer les types de requête à partir du nom de route

type RequestStructMap = {
  CreateAccount: CreateAccount;
  UpdateAccount: UpdateAccount;
  AccountEmail: AccountEmail;
  CreateAccountWithoutAuth: CreateAccountWithoutAuth;
  CreateAccountAddToCompany: CreateAccountAddToCompany;
  UpdatePassword: UpdatePassword;
  Password: Password;
  Login: Login;
  DeviceType: DeviceType;
  DeviceUuid: DeviceUuid;
  CreateDevice: CreateDevice;
  UpdateDevice: UpdateDevice;
  CreateCompany: CreateCompany;
  Company: Company;
  CompanyId: CompanyId;
  BuildingId: BuildingId;
  CreateBuilding: CreateBuilding;
  Building: Building;
  BreedingId: BreedingId;
  CreateBreeding: CreateBreeding;
  Breeding: Breeding;
  AssociateDeviceToUser: AssociateDeviceToUser;
  LicensePost: LicensePost;
  LicenseDelete: LicenseDelete;
  LicenseOrders: LicenseOrders;
  LicenseRegulate: LicenseRegulate;
  x: undefined;
};

type ResponseStructMap = {
  AccountWithoutPassword: AccountWithoutPassword;
  AccountList: AccountList;
  AllDataAccountList: AllDataAccountList;
  DeviceWithoutLegacyPasswordList2: DeviceWithoutLegacyPasswordList2;
  DeviceWithoutLegacyPasswordList: DeviceWithoutLegacyPasswordList;
  DeviceWithoutLegacyPassword: DeviceWithoutLegacyPassword;
  AllDataDeviceList: AllDataDeviceList;
  CompanyList: CompanyList;
  Company: Company;
  BuildingList: BuildingList;
  Building: Building;
  BreedingList: BreedingList;
  Breeding: Breeding;
  BatchList: BatchList;
  RemoteConnectionPage: RemoteConnectionPage;
  LoginHistoryPage: LoginHistoryPage;
  LicenseHistoryPage: LicenseHistoryPage;
  LicenseProviderList: LicenseProviderList;
  x: undefined;
};

export type RouteName = keyof typeof routes;
export type RequestTypeOf<K extends keyof typeof routes> =
  RequestStructMap[(typeof routes)[K]["request"]];
export type ResponseTypeOf<K extends keyof typeof routes> =
  ResponseStructMap[(typeof routes)[K]["response"]];
